/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TradeDesignManagerPdpLauncher_item$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubbleDesignManager_item$ref: FragmentReference;
export type PdpRespIconBubbleDesignManager_item = {|
  +$fragmentRefs: TradeOnboardingCoachmarkConditionalLoader_item$ref & TradeDesignManagerPdpLauncher_item$ref,
  +$refType: PdpRespIconBubbleDesignManager_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbleDesignManager_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeDesignManagerPdpLauncher_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '677ad56f266587a9d5fcbba1f7a4da70';
module.exports = node;
